<template>
    <CollapsibleCard title="Teams looking for players">
        <template v-slot:content>
            <div v-if="loading" class="d-flex align-center justify-center">
                <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
            </div>
            <template v-else>
                <div class="mb-4 z-no-user-select" style="word-break:break-word">
                    <a @click="selectSport(sport)" v-for="sport in sports" :key="sport.id" class="mr-2" :class="{'font-weight-bold': sport.id == selectedSport}">{{ sport.name }}</a>
                </div>

                <div v-if="posts.length == 0" class="text--disabled">
                    {{ $translate('No teams looking for players right now') }}
                </div>

                <TeamsportPlayerPoolPost
                    v-for="post in filteredPosts" :key="post.id"
                    :post="post"
                    type="team"
                    :showReplyButton="true"
                    :showEditButton="false"
                    class="mb-4"
                >
                    <template #title>
                        <div class="font-weight-bold">{{ post.group.name }}</div>
                    </template>
                </TeamsportPlayerPoolPost>
            </template>
        </template>
    </CollapsibleCard>
</template>

<script>
import CollapsibleCard from '../components/CollapsibleCard.vue'
import TeamsportPlayerPoolPost from './TeamsportPlayerPoolPost.vue'
export default {
    name: 'zoezi-teamsport-player-pool-teams-looking-for-players-card',
    props: {
        teamsports: {
            type: Array
        },
        posts: {
            type: Array
        }
    },
    components: {
        CollapsibleCard,
        TeamsportPlayerPoolPost
    },
    data: () => ({
        loading: false,
        selectedSport: null,
    }),
    computed: {
        filteredPosts() {
            if (!this.selectedSport) {
                return this.posts;
            }

            return this.posts.filter(post => post.group.teamsport_id == this.selectedSport);
        },
        sports() {
            let res = [];
            this.posts.forEach((post) => {
                if (!res.find(sport => sport.id == post.group.teamsport_id)) {
                    let sport = this.teamsports.find(teamsport => teamsport.id == post.group.teamsport_id)
                    if (sport) {
                        res.push(sport);
                    }
                }
            });

            return res.sort((a, b) => a.name.localeCompare(b.name));
        }
    },
    methods: {
        selectSport(sport) {
            if (this.selectedSport === sport.id) {
                this.selectedSport = null;
            } else {
                this.selectedSport = sport.id;
            }
        }
    }
}
</script>
